module.exports = __webpack_public_path__ + "avatar.png?e4ccac92420a623496a8cbdb0217723d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = 73
// module chunks = 0